import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ICONS } from '@app/styles';
import { Button, getElementCenterPos, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp, mouseInteractivity_ToolTip, openContent } from '@nu-art/thunderstorm-frontend';
import './Component_AddEntity.scss';
import { UtilObject_Pathway } from '@app/pathway-frontend/search/items/pathway';
import { UtilObject_Action } from '@app/pathway-frontend/search/items/action';
import { UtilObject_OrderGroup } from '@app/pathway-frontend/search/items/order-group';
import { UtilObject_DiseaseProfile } from '@app/dp-frontend/search/index';
import { UtilObject_Resource } from '@app/hcs-frontend/search/items/resource';
import { UtilObject_ContextRule } from '@app/hcs-frontend/search/items/context-rule';
import { UtilObject_FindingView } from '@app/advisor-ui-frontend/search/items/finding-view';
import { UtilObject_FAQ } from '@app/advisor-ui-frontend/search/items/faq';
import { UtilObject_FHIRResource } from '@app/fhir-frontend/search/items/fhir-resource';
import { UtilObject_FHIRQuery } from '@app/fhir-frontend/search/items/fhir-query';
import { UtilObject_FlowSheet } from '@app/advisor-content-frontend/search/items/flow-sheet';
import { UtilObject_NoteTemplate } from '@app/advisor-content-frontend/search/items/note-template';
import { UtilObject_LogTemplate } from '@app/advisor-content-frontend/search/items/log-template';
import { UtilObject_AdvisorWizard } from '@app/advisor-content-frontend/search/items/advisor-wizard';
import { UtilObject_AdvisorSnippet } from '@app/advisor-content-frontend/search/items/advisor-snippet';
import { UtilObject_Reference } from '@app/hcs-frontend/search/items/reference';
import { UtilObject_AIPrompt } from '@app/styles/ai-prompts/integration';
import { UtilObject_PertinentCategory } from '@app/advisor-ui-frontend/search/index';
const actions = [
    {
        label: 'Pathway',
        action: () => UtilObject_Pathway.openEditor(undefined),
    },
    {
        label: 'Disease Profile',
        action: () => UtilObject_DiseaseProfile.openNew(),
    },
    {
        label: 'Action',
        action: () => UtilObject_Action.openEditor(undefined),
    },
    {
        label: 'Order Group',
        action: () => UtilObject_OrderGroup.openEditor(undefined),
    },
    {
        label: 'Resource',
        action: () => UtilObject_Resource.openEditor(undefined),
    },
    {
        label: 'Context Rule',
        action: () => UtilObject_ContextRule.openEditor(undefined),
    },
    {
        label: 'Finding View',
        action: () => UtilObject_FindingView.openEditor(undefined),
    },
    {
        label: 'FAQ',
        action: () => UtilObject_FAQ.openEditor(undefined),
    },
    {
        label: 'FHIR Resource',
        action: () => UtilObject_FHIRResource.openEditor(undefined),
    },
    {
        label: 'FHIR Query',
        action: () => UtilObject_FHIRQuery.openEditor(undefined),
    },
    {
        label: 'Flow Sheet',
        action: () => UtilObject_FlowSheet.openEditor(undefined),
    },
    {
        label: 'Note Template',
        action: () => UtilObject_NoteTemplate.openEditor(undefined),
    },
    {
        label: 'Log Template',
        action: () => UtilObject_LogTemplate.openEditor(undefined),
    },
    {
        label: 'Advisor Wizard',
        action: () => UtilObject_AdvisorWizard.openEditor(undefined),
    },
    {
        label: 'Advisor Snippet',
        action: () => UtilObject_AdvisorSnippet.openEditor(undefined),
    },
    {
        label: 'Reference',
        action: () => UtilObject_Reference.openEditor(undefined),
    },
    {
        label: 'AI Prompt',
        action: () => UtilObject_AIPrompt.openEditor(undefined),
    },
    {
        label: 'Pertinent Category',
        action: () => UtilObject_PertinentCategory.openEditor(undefined),
    }
];
const openAddEntityPopUp = (e) => {
    e.stopPropagation();
    const model = {
        id: 'pop-up__add-entity',
        originPos: getElementCenterPos(e.currentTarget),
        modalPos: { x: -1, y: 1 },
        offset: { x: -8, y: 8 },
        content: () => _jsx(_Fragment, { children: actions.map((action, index) => {
                return _jsx(Button, { variant: 'text', onClick: () => {
                        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                        action.action();
                    }, children: action.label }, index);
            }) })
    };
    ModuleFE_MouseInteractivity.hide(mouseInteractivity_ToolTip);
    ModuleFE_MouseInteractivity.showContent(model);
};
export const Component_AddEntity = () => {
    return _jsx(ICONS.advisor_v5_plus.component, { className: 'c__add-entity', ...openContent.tooltip.bottom('tooltip__add-entity', 'Add a new entity in the system', { offset: 8 }), onClick: openAddEntityPopUp });
};
